import { Component, DOCUMENT, Inject, OnInit, Renderer2 } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";

import { environment } from "../environments/environment";

@Component({
  selector: "gnl-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = "Customer Portal";

  constructor(
    private router: Router,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.renderDataCapScript();
  }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 130);
      }
    });
  }

  renderDataCapScript() {
    const dataCapIntegrity = environment.dataCapIntegrity;
    const dataCapScript = this.renderer.createElement("script");
    dataCapScript.src = environment.dataCapScript;
    dataCapScript.integrity = dataCapIntegrity;
    dataCapScript.crossOrigin = environment.dataCapCrossOrigin;
    this.renderer.appendChild(this.document.head, dataCapScript);
  }
}
